import { render, staticRenderFns } from "./OppotunityDetail-Notes.vue?vue&type=template&id=4d12192a&scoped=true"
import script from "./OppotunityDetail-Notes.vue?vue&type=script&lang=js"
export * from "./OppotunityDetail-Notes.vue?vue&type=script&lang=js"
import style0 from "./OppotunityDetail-Notes.vue?vue&type=style&index=0&id=4d12192a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12192a",
  null
  
)

export default component.exports